import { useState } from "react";
import { TaskForm } from "../pages/project/TaskForm";

import { TaskList } from "../pages/project/TaskList";

export const Tabs = (project) => {
    //console.log(project)
  const [toggleState, setToggleState] = useState("tasks");

  const toggleTab = (e) => {
    setToggleState(e);
  };

  return (
    
    <>
      <div className="border-b border-gray-200 dark:border-gray-700">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <div
              className={
                toggleState === "tasks"
                  ? "inline-block py-4 px-4 text-sm font-medium text-center text-blue-600 rounded-t-lg border-b-2 border-blue-600 active"
                  : "inline-block py-4 px-4 text-sm font-medium text-center text-gray-500 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
              }
              onClick={() => toggleTab("tasks")}
            >
              Tasks
            </div>
          </li>
          <li className="mr-2">
            <div
              onClick={() => toggleTab("overview")}
              className={
                toggleState === "overview"
                  ? "inline-block py-4 px-4 text-sm font-medium text-center text-blue-600 rounded-t-lg border-b-2 border-blue-600 active"
                  : "inline-block py-4 px-4 text-sm font-medium text-center text-gray-500 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
              }
            >
              Project Overview
            </div>
          </li>
          <li className="mr-2">
            <div
              onClick={() => toggleTab("notes")}
              className={
                toggleState === "notes"
                  ? "inline-block py-4 px-4 text-sm font-medium text-center text-blue-600 rounded-t-lg border-b-2 border-blue-600 active"
                  : "inline-block py-4 px-4 text-sm font-medium text-center text-gray-500 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
              }
            >
              Notes
            </div>
          </li>
          <li className="mr-2">
            <div
              onClick={() => toggleTab("files")}
              className={
                toggleState === "files"
                  ? "inline-block py-4 px-4 text-sm font-medium text-center text-blue-600 rounded-t-lg border-b-2 border-blue-600 active"
                  : "inline-block py-4 px-4 text-sm font-medium text-center text-gray-500 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
              }
            >
              Files
            </div>
          </li>
          <li className="mr-2">
            <div
              onClick={() => toggleTab("activity")}
              className={
                toggleState === "activity"
                  ? "inline-block py-4 px-4 text-sm font-medium text-center text-blue-600 rounded-t-lg border-b-2 border-blue-600 active"
                  : "inline-block py-4 px-4 text-sm font-medium text-center text-gray-500 rounded-t-lg border-b-2 border-transparent hover:text-gray-600 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300"
              }
            >
              Activity
            </div>
          </li>
        </ul>
      </div>
      {toggleState === 'tasks' && (
          <>
          <TaskForm />     
           <TaskList />
          </>
           
      ) }
      {toggleState === 'overview'}
      {toggleState === 'notes' && (
           <p>notes will be here.</p>
      ) }
      {toggleState === 'files' && (
           <p>files will be here.</p>
      ) }
      {toggleState === 'activity' && (
           <p>activity will be here.</p>
      ) }
      {project.name}
    </>
  );
};
